<template>
    <div v-if="shipmentInfo.dangerousGoods != null">
        <h6 style="font-weight: bold">{{ title }}</h6>
        <span>{{ $t('history.label.Type') }}: {{ shipmentInfo.dangerousGoods.type }}<br /></span>
        <span
            >{{ $t('history.label.UNNumber') }}: {{ shipmentInfo.dangerousGoods.unNumber }}<br
        /></span>
    </div>
</template>
<script>
import localization from '@/mixins/localizationMixin';

export default {
    components: {},

    mixins: [localization],

    props: {
        title: { type: String, required: true },
        shipment: { type: Object, required: true },
        shipmentInfo: { type: Object, required: true }
    },

    data() {
        return {};
    },

    methods: {}
};
</script>

<style></style>
